/**
 * Digital wallet (Apple Pay / Google Pay) copy used by DigitalWalletButton
 * in vaiu-app and vaiu-merchant-app. Spread into each app's TopUpBalance i18n.
 */
export const digitalWalletTranslations = {
  en: {
    'vaiu.topup.wallet.checking': 'Checking Apple Pay and Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay and Google Pay are not available in this browser.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS for Apple Pay; Chrome, Edge, or Android Chrome for Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost is OK) and a card saved in the wallet',
    'vaiu.topup.wallet.hint.iframe': 'If this page is in an iframe, the iframe must include allow="payment"',
    'vaiu.topup.wallet.use_card': 'Please use a card instead.',
    'vaiu.topup.wallet.processing': 'Processing...',
    'vaiu.topup.wallet.unavailable_amount': 'Unavailable for this amount',
    'vaiu.topup.wallet.secure': 'Fast, secure payment with Apple Pay, Google Pay, or Link',
    'vaiu.topup.wallet.payment_failed': 'Payment failed',
  },
  fr: {
    'vaiu.topup.wallet.checking': 'Vérification d’Apple Pay et Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay et Google Pay ne sont pas disponibles dans ce navigateur.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS pour Apple Pay ; Chrome, Edge ou Chrome Android pour Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost est accepté) et une carte enregistrée dans le portefeuille',
    'vaiu.topup.wallet.hint.iframe': 'Si cette page est dans une iframe, l’iframe doit inclure allow="payment"',
    'vaiu.topup.wallet.use_card': 'Veuillez utiliser une carte à la place.',
    'vaiu.topup.wallet.processing': 'Traitement...',
    'vaiu.topup.wallet.unavailable_amount': 'Indisponible pour ce montant',
    'vaiu.topup.wallet.secure': 'Paiement rapide et sécurisé avec Apple Pay, Google Pay ou Link',
    'vaiu.topup.wallet.payment_failed': 'Échec du paiement',
  },
  es: {
    'vaiu.topup.wallet.checking': 'Comprobando Apple Pay y Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay y Google Pay no están disponibles en este navegador.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS para Apple Pay; Chrome, Edge o Chrome para Android para Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost es válido) y una tarjeta guardada en la billetera',
    'vaiu.topup.wallet.hint.iframe': 'Si esta página está en un iframe, el iframe debe incluir allow="payment"',
    'vaiu.topup.wallet.use_card': 'Use una tarjeta en su lugar.',
    'vaiu.topup.wallet.processing': 'Procesando...',
    'vaiu.topup.wallet.unavailable_amount': 'No disponible para este importe',
    'vaiu.topup.wallet.secure': 'Pago rápido y seguro con Apple Pay, Google Pay o Link',
    'vaiu.topup.wallet.payment_failed': 'El pago falló',
  },
  sq: {
    'vaiu.topup.wallet.checking': 'Duke kontrolluar Apple Pay dhe Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay dhe Google Pay nuk janë të disponueshme në këtë shfletues.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS për Apple Pay; Chrome, Edge ose Chrome për Android për Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost është i pranueshëm) dhe një kartë e ruajtur në portofol',
    'vaiu.topup.wallet.hint.iframe': 'Nëse kjo faqe është në një iframe, iframe-i duhet të përfshijë allow="payment"',
    'vaiu.topup.wallet.use_card': 'Ju lutemi përdorni një kartë.',
    'vaiu.topup.wallet.processing': 'Duke procesuar...',
    'vaiu.topup.wallet.unavailable_amount': 'I padisponueshëm për këtë shumë',
    'vaiu.topup.wallet.secure': 'Pagesë e shpejtë dhe e sigurt me Apple Pay, Google Pay ose Link',
    'vaiu.topup.wallet.payment_failed': 'Pagesa dështoi',
  },
  ru: {
    'vaiu.topup.wallet.checking': 'Проверка Apple Pay и Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay и Google Pay недоступны в этом браузере.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS для Apple Pay; Chrome, Edge или Chrome для Android для Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost допустим) и карта, сохранённая в кошельке',
    'vaiu.topup.wallet.hint.iframe': 'Если страница открыта в iframe, у iframe должен быть атрибут allow="payment"',
    'vaiu.topup.wallet.use_card': 'Используйте карту.',
    'vaiu.topup.wallet.processing': 'Обработка...',
    'vaiu.topup.wallet.unavailable_amount': 'Недоступно для этой суммы',
    'vaiu.topup.wallet.secure': 'Быстрая и безопасная оплата через Apple Pay, Google Pay или Link',
    'vaiu.topup.wallet.payment_failed': 'Оплата не удалась',
  },
  pt: {
    'vaiu.topup.wallet.checking': 'A verificar Apple Pay e Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay e Google Pay não estão disponíveis neste navegador.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS para Apple Pay; Chrome, Edge ou Chrome para Android para Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost é aceite) e um cartão guardado na carteira',
    'vaiu.topup.wallet.hint.iframe': 'Se esta página estiver num iframe, o iframe deve incluir allow="payment"',
    'vaiu.topup.wallet.use_card': 'Utilize um cartão.',
    'vaiu.topup.wallet.processing': 'A processar...',
    'vaiu.topup.wallet.unavailable_amount': 'Indisponível para este valor',
    'vaiu.topup.wallet.secure': 'Pagamento rápido e seguro com Apple Pay, Google Pay ou Link',
    'vaiu.topup.wallet.payment_failed': 'Pagamento falhou',
  },
  el: {
    'vaiu.topup.wallet.checking': 'Έλεγχος Apple Pay και Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Το Apple Pay και το Google Pay δεν είναι διαθέσιμα σε αυτό το πρόγραμμα περιήγησης.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS για Apple Pay· Chrome, Edge ή Chrome για Android για Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (το localhost είναι αποδεκτό) και μια κάρτα αποθηκευμένη στο πορτοφόλι',
    'vaiu.topup.wallet.hint.iframe': 'Αν αυτή η σελίδα είναι σε iframe, το iframe πρέπει να περιλαμβάνει allow="payment"',
    'vaiu.topup.wallet.use_card': 'Χρησιμοποιήστε κάρτα.',
    'vaiu.topup.wallet.processing': 'Επεξεργασία...',
    'vaiu.topup.wallet.unavailable_amount': 'Μη διαθέσιμο για αυτό το ποσό',
    'vaiu.topup.wallet.secure': 'Γρήγορη και ασφαλής πληρωμή με Apple Pay, Google Pay ή Link',
    'vaiu.topup.wallet.payment_failed': 'Η πληρωμή απέτυχε',
  },
  de: {
    'vaiu.topup.wallet.checking': 'Apple Pay und Google Pay werden geprüft…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay und Google Pay sind in diesem Browser nicht verfügbar.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS für Apple Pay; Chrome, Edge oder Chrome für Android für Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost ist zulässig) und eine im Wallet gespeicherte Karte',
    'vaiu.topup.wallet.hint.iframe': 'Wenn diese Seite in einem iframe ist, muss das iframe allow="payment" enthalten',
    'vaiu.topup.wallet.use_card': 'Bitte verwenden Sie stattdessen eine Karte.',
    'vaiu.topup.wallet.processing': 'Wird verarbeitet...',
    'vaiu.topup.wallet.unavailable_amount': 'Für diesen Betrag nicht verfügbar',
    'vaiu.topup.wallet.secure': 'Schnelle, sichere Zahlung mit Apple Pay, Google Pay oder Link',
    'vaiu.topup.wallet.payment_failed': 'Zahlung fehlgeschlagen',
  },
  ro: {
    'vaiu.topup.wallet.checking': 'Se verifică Apple Pay și Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay și Google Pay nu sunt disponibile în acest browser.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS pentru Apple Pay; Chrome, Edge sau Chrome pentru Android pentru Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost este acceptat) și un card salvat în portofel',
    'vaiu.topup.wallet.hint.iframe': 'Dacă această pagină este într-un iframe, iframe-ul trebuie să includă allow="payment"',
    'vaiu.topup.wallet.use_card': 'Folosiți un card.',
    'vaiu.topup.wallet.processing': 'Se procesează...',
    'vaiu.topup.wallet.unavailable_amount': 'Indisponibil pentru această sumă',
    'vaiu.topup.wallet.secure': 'Plată rapidă și sigură cu Apple Pay, Google Pay sau Link',
    'vaiu.topup.wallet.payment_failed': 'Plata a eșuat',
  },
  sr: {
    'vaiu.topup.wallet.checking': 'Провера Apple Pay и Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay и Google Pay нису доступни у овом прегледачу.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS за Apple Pay; Chrome, Edge или Chrome за Android за Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost је дозвољен) и картица сачувана у новчанику',
    'vaiu.topup.wallet.hint.iframe': 'Ако је ова страница у iframe-у, iframe мора да укључи allow="payment"',
    'vaiu.topup.wallet.use_card': 'Користите картицу.',
    'vaiu.topup.wallet.processing': 'Обрада...',
    'vaiu.topup.wallet.unavailable_amount': 'Није доступно за овај износ',
    'vaiu.topup.wallet.secure': 'Брзо и безбедно плаћање уз Apple Pay, Google Pay или Link',
    'vaiu.topup.wallet.payment_failed': 'Плаћање није успело',
  },
  pl: {
    'vaiu.topup.wallet.checking': 'Sprawdzanie Apple Pay i Google Pay…',
    'vaiu.topup.wallet.unavailable': 'Apple Pay i Google Pay nie są dostępne w tej przeglądarce.',
    'vaiu.topup.wallet.hint.browsers': 'Safari / iOS dla Apple Pay; Chrome, Edge lub Chrome na Androida dla Google Pay',
    'vaiu.topup.wallet.hint.https': 'HTTPS (localhost jest dozwolony) i karta zapisana w portfelu',
    'vaiu.topup.wallet.hint.iframe': 'Jeśli ta strona jest w ramce iframe, iframe musi zawierać allow="payment"',
    'vaiu.topup.wallet.use_card': 'Użyj karty.',
    'vaiu.topup.wallet.processing': 'Przetwarzanie...',
    'vaiu.topup.wallet.unavailable_amount': 'Niedostępne dla tej kwoty',
    'vaiu.topup.wallet.secure': 'Szybka i bezpieczna płatność przez Apple Pay, Google Pay lub Link',
    'vaiu.topup.wallet.payment_failed': 'Płatność nie powiodła się',
  },
} as const;
